import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Progress, Typography } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { removeStorageWhenLogout, setHtmlStorage, statusHtmlStorage } from "../../config/helper";
import * as actionAuth from "../../store/auth/action";
import * as actionProfile from "../../store/profile/action";
import onboard1 from "../../assets/img/icon-onboard-1.png";
import onboard2 from "../../assets/img/icon-onboard-2.png";
import onboard3 from "../../assets/img/icon-onboard-3.png";
import "./onboarding.css";

class Onboarding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: "one",
    };
  }

  componentDidMount() {
    if (!statusHtmlStorage("accessToken")) {
      // this.authRefresh();
    } else {
      this.getProfile();
    }
    if (
      sessionStorage.getItem("onboard-step") !== "null" &&
      sessionStorage.getItem("onboard-step") === "finish"
    ) {
      window.location.href = "/";
    }
  }

  authRefresh = async () => {
    await this.props.authRefresh();
    if (this.props.refreshResponse.httpStatus === 401) {
      removeStorageWhenLogout();
      window.location.href = "/signin";
    } else {
      setHtmlStorage("accessToken", this.props.refreshResponse.data.token);
      window.location.reload();
    }
  };

  getProfile = async () => {
    await this.props.getProfile();
  };

  handleFinishButton = () => {
    sessionStorage.setItem("onboard-step", "finish");
    window.location.href = "/";
  };

  render() {
    return (
      <div className="onboarding">
        <div className="onboarding-wrapper">
          {this.state.step === "one" && (
            <>
              <div className="top-section">
                <img src={onboard1} alt="Onboarding First Step" />
              </div>
              <div className="middle-section">
                <div className="message-wrapper">
                  <Typography.Title level={3}>
                    New Way of Friendship
                  </Typography.Title>
                  <Typography.Paragraph>
                    Experience a genuine connection that transcends the virtual
                    world and is on your terms.
                  </Typography.Paragraph>
                </div>
              </div>
              <div className="bottom-section">
                <div className="btn-cta-wrapper">
                  <Progress type="circle" percent={Math.round(100 / 3)} />
                  <Button
                    icon={<ArrowRightOutlined />}
                    onClick={() => this.setState({ step: "two" })}
                  />
                </div>
              </div>
            </>
          )}
          {this.state.step === "two" && (
            <>
              <div className="top-section">
                <img src={onboard2} alt="Onboarding Second Step" />
              </div>
              <div className="middle-section">
                <div className="message-wrapper">
                  <Typography.Title level={3}>Made For You</Typography.Title>
                  <Typography.Paragraph>
                    Personalize its traits to help it understand your emotions,
                    interests, and even your sense of humor.
                  </Typography.Paragraph>
                </div>
              </div>
              <div className="bottom-section">
                <div className="btn-cta-wrapper">
                  <Progress type="circle" percent={Math.round((100 * 2) / 3)} />
                  <Button
                    icon={<ArrowRightOutlined />}
                    onClick={() => this.setState({ step: "three" })}
                  />
                </div>
              </div>
            </>
          )}
          {this.state.step === "three" && (
            <>
              <div className="top-section">
                <img src={onboard3} alt="Onboarding Third Step" />
              </div>
              <div className="middle-section">
                <div className="message-wrapper">
                  <Typography.Title level={3}>
                    Talk How You Speak
                  </Typography.Title>
                  <Typography.Paragraph>
                    Engage in voice chats that mimic real-life interactions
                    instead of typing, creating a more immersive and natural
                    connection.
                  </Typography.Paragraph>
                </div>
              </div>
              <div className="bottom-section">
                <div className="btn-cta-wrapper">
                  <Progress
                    type="circle"
                    percent={100}
                    strokeColor={"#0A89FF"}
                  />
                  <Button onClick={() => this.handleFinishButton()}>
                    READY
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

const stateToProps = (state) => {
  const { auth, profile } = state;
  return {
    refreshResponse: auth.refreshResponse,
    profile: profile.profile,
  };
};

const dispatchToProps = (dispatch) => ({
  authRefresh: () => dispatch(actionAuth.authRefresh()),
  getProfile: () => dispatch(actionProfile.getProfile()),
});

export default connect(stateToProps, dispatchToProps)(Onboarding);
